export const isAndroid = window.navigator.userAgent.toLowerCase().includes('android');
